import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=703853d9"
import script from "../services/about-us.js?vue&type=script&lang=js&external"
export * from "../services/about-us.js?vue&type=script&lang=js&external"
import style0 from "../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/about-us.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports